import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-section-message',
  templateUrl: './section-message.component.html',
  styleUrls: ['./section-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionMessageComponent {}
